<template>
  <div class="item">
    <div v-if="isIncludes('image')" class="img">
      <img :src="getItemThumb(item)" alt="">
      <button v-if="collectionIcon"
        type="button"
        class="btnCollection"
        @click.stop="deleteCollection(item.collectionItemId)">
        <img :src="collectionIcon.active" alt="" :style="{width: collectionIcon.size}">
      </button>
    </div>
    <div class="text">
      <div class="left">
        <div v-if="isIncludes('name')" class="name" :style="itemStyle.name">
          {{ item.collectionItemName[lang] }}
        </div>
        <div v-if="isIncludes('descTop')" class="descTop" :style="itemStyle.descTop">
          <pre>{{ item.attribute.descTop[lang] }}</pre>
        </div>
      </div>
      <div class="right">
        <div v-if="isIncludes('descBottom')" class="descBottom" :style="itemStyle.descBottom">
          <pre>{{ item.attribute.descBottom[lang] }}</pre>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CollectionItem',
  props: [
    'locale',
    'lang',
    'categoryId',
    'item',
    'collectionIcon',
    'itemDisplay'
  ],
  computed: {
    itemStyle () {
      const spacing = this.$store.getters['collection/getCommonItemStyle']
      return {
        ...spacing && spacing.name && {
          name: {
            letterSpacing: spacing.name
          }
        },
        ...spacing && spacing.descTop && {
          descTop: {
            letterSpacing: spacing.descTop
          }
        },
        ...spacing && spacing.descBottom && {
          descBottom: {
            letterSpacing: spacing.descBottom
          }
        }
      }
    }
  },
  methods: {
    isIncludes (el) {
      return this.itemDisplay && this.itemDisplay.includes(el)
    },
    getItemThumb (item) {
      return item && item.attribute && item.attribute.image
    },
    async deleteCollection (collectionItemId) {
      this.$emit('deleteItem', collectionItemId)
    }
  }
}
</script>